/**
 * facePaint — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const facePaintPack: ToilePack = {
    slug: 'face-paint',
    category: 'facepaint',
    name: 'Face paint designs',
    tagline: tagline('designs', 'characters', 'styles'),
    chips: chips('characters', 'styles'),
    ratio: A4,
    readings: [
        {key: 'butterfly', label: 'Butterfly', subject: 'wings spreading from the nose across both eyes'},
        {key: 'tiger', label: 'Tiger', subject: 'a white muzzle, orange cheeks and black stripes'},
        {key: 'superhero', label: 'Superhero mask', subject: 'a masked band across the eyes with a pointed peak'},
    ],
    styles: [
        {key: 'steps', label: 'Kids steps', style: 'three progressive stages side by side', palette: 'few broad sponge strokes', framing: 'quick to paint, no numbers'},
        {key: 'glitter', label: 'Festival glitter', style: 'chunky glitter, gems set along the brow', palette: 'pearl shimmer and metallic accents', framing: 'straight on, plain neutral ground'},
        {key: 'pro', label: 'Pro detailed', style: 'airbrushed gradients and fine detail brushwork', palette: 'crisp white highlights, deep shadow', framing: 'straight on, plain neutral ground'},
    ],
    directions: ['a dragon instead', 'in purple and teal', 'on one cheek only'],
}
